import { ClaimWorkflowConfiguration, ClaimWorkflowConfigurationOptions, CoreFetch, WorkerApi } from '../../api';

export type WorkerConfigurationApiMode = 'provider' | 'support';

export async function fetchClaimWorkflowConfiguration(
    apiMode: WorkerConfigurationApiMode,
): Promise<ClaimWorkflowConfiguration> {
    const api = CoreFetch<WorkerApi>(WorkerApi);

    if (apiMode === 'provider') {
        return api.getClaimWorkflowConfigurationProvider();
    }

    return api.getClaimWorkflowConfiguration();
}

export async function fetchClaimWorkflowConfigurationOptions(
    apiMode: WorkerConfigurationApiMode,
): Promise<ClaimWorkflowConfigurationOptions[]> {
    const api = CoreFetch<WorkerApi>(WorkerApi);

    if (apiMode === 'provider') {
        return api.getClaimWorkflowConfigurationOptionsProvider();
    }

    return api.getClaimWorkflowConfigurationOptions();
}
